module.exports = __webpack_public_path__ + "static/media/logoCencor.62d32eaa.png";